import {useContext, useEffect} from "react";
import {OrgCustomizationContext} from "../themes/OrgCustomizationProvider";

const GoogleAnalytics: React.FC = ({children}) => {
    const {googleAnalytics, loadingOrgConfiguration} = useContext(OrgCustomizationContext);

    useEffect(() => {
        if (googleAnalytics && !loadingOrgConfiguration) {
            const options = Object.keys(googleAnalytics.Options || {})
                // @ts-ignore
                .map(k => `${k}=${googleAnalytics.Options[k]}`)
                .join('&')
            const script = document.createElement('script')
            script.textContent = `
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl${options ? `+'&${options}'` : ''};f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${googleAnalytics.Id}');
            `
            document.head.prepend(script)

            const noscript = document.createElement('noscript')
            const iframe = document.createElement('iframe')
            iframe.src = `https://www.googletagmanager.com/ns.html?id=${googleAnalytics.Id}${options ? `&${options}` : ''}`
            iframe.height = '0'
            iframe.width = '0'
            iframe.setAttribute('style', 'display:none;visibility:hidden')
            noscript.appendChild(iframe)
            document.body.prepend(noscript)
        }
    }, [googleAnalytics, loadingOrgConfiguration])

    return <>{children}</>;
}

export default GoogleAnalytics
